<template>
    <div class="container">
        <div class="page-title">Гарантия и возврат</div>
        <div class="warranties section">
            <div class="warranties-switcher">
                <div class="warranties-switcher__item"
                     :class="{'active': active_tab === 0}"
                     @click="setActive(0)"
                >
                    <div>
                        Возврат товара ненадлежащего качества
                    </div>
                    <chevron-right-icon size="1.5x" class="custom-class"></chevron-right-icon>
                </div>
                <div class="warranties-switcher__item"
                     :class="{'active': active_tab === 1}"
                     @click="setActive(1)"
                >
                    <div>
                        Возврат товара ненадлежащего качества
                    </div>
                    <chevron-right-icon size="1.5x" class="custom-class"></chevron-right-icon>

                </div>
                <div class="warranties-switcher__item"
                     :class="{'active': active_tab === 2}"
                     @click="setActive(2)"
                >
                    <div>
                        Способы возврата и замены товара
                    </div>
                    <chevron-right-icon size="1.5x" class="custom-class"></chevron-right-icon>

                </div>
                <div class="warranties-switcher__item"
                     :class="{'active': active_tab === 3}"
                     @click="setActive(3)"
                >
                    <div>
                        Способы возврата и замены товара
                    </div>
                    <chevron-right-icon size="1.5x" class="custom-class"></chevron-right-icon>

                </div>
            </div>
            <div class="warranties__content">
                <page1 v-if="active_tab === 0" />
                <page2 v-if="active_tab === 1"/>
            </div>
        </div>
    </div>
</template>

<script>
    import Page1 from '../components/Warranties/page1';
    import Page2 from '../components/Warranties/page2';
    import { ChevronRightIcon } from 'vue-feather-icons'

    export default {
        name: "WarrantiesPage",
        components: { Page2, Page1, ChevronRightIcon },
        data() {
            return {
                active_tab: 0
            }
        },
        methods: {
            setActive(tab) {
                this.active_tab = tab;
            }
        }
    };
</script>

<style scoped lang="scss">
    .warranties {
        display: flex;
        width: 100%;
        &-switcher {
            width: 100%;
            max-width: 385px;
            &__item {
                display: flex;
                justify-content: space-between;
                color: #3F4450;
                font-weight: 500;
                font-size: 16px;
                line-height: 21px;
                padding: 16px 0px 16px 0;
                border-top: 1px solid #E1E6EA;
                svg {
                    color: #6BBCBA;
                }
                &:last-child {
                    border-bottom: 1px solid #E1E6EA;
                }
                &:hover {
                    cursor: pointer;
                }
                &.active {
                    color: #6BBCBA;
                }
            }
        }
        &__content {
            margin-left: 32px;
        }
    }
</style>
